__turbopack_context__.v({
  "advertiseGrid": "TherapistsPage-module__nde4IG__advertiseGrid",
  "bounce": "TherapistsPage-module__nde4IG__bounce",
  "btn": "TherapistsPage-module__nde4IG__btn",
  "btnCtaPrimary": "TherapistsPage-module__nde4IG__btnCtaPrimary",
  "btnCtaSecondary": "TherapistsPage-module__nde4IG__btnCtaSecondary",
  "btnGradientPrimary": "TherapistsPage-module__nde4IG__btnGradientPrimary",
  "btnPrimary": "TherapistsPage-module__nde4IG__btnPrimary",
  "btnSecondary": "TherapistsPage-module__nde4IG__btnSecondary",
  "card": "TherapistsPage-module__nde4IG__card",
  "cardElevated": "TherapistsPage-module__nde4IG__cardElevated",
  "contactInfo": "TherapistsPage-module__nde4IG__contactInfo",
  "contactItem": "TherapistsPage-module__nde4IG__contactItem",
  "contactSection": "TherapistsPage-module__nde4IG__contactSection",
  "container": "TherapistsPage-module__nde4IG__container",
  "ctaButtons": "TherapistsPage-module__nde4IG__ctaButtons",
  "ctaButtonsInline": "TherapistsPage-module__nde4IG__ctaButtonsInline",
  "ctaSection": "TherapistsPage-module__nde4IG__ctaSection",
  "featureCard": "TherapistsPage-module__nde4IG__featureCard",
  "featuresGrid": "TherapistsPage-module__nde4IG__featuresGrid",
  "featuresSection": "TherapistsPage-module__nde4IG__featuresSection",
  "float": "TherapistsPage-module__nde4IG__float",
  "floatContent": "TherapistsPage-module__nde4IG__floatContent",
  "fullTape": "TherapistsPage-module__nde4IG__fullTape",
  "glow": "TherapistsPage-module__nde4IG__glow",
  "grayscale": "TherapistsPage-module__nde4IG__grayscale",
  "hero": "TherapistsPage-module__nde4IG__hero",
  "heroContent": "TherapistsPage-module__nde4IG__heroContent",
  "heroSubtitle": "TherapistsPage-module__nde4IG__heroSubtitle",
  "loadingSpinner": "TherapistsPage-module__nde4IG__loadingSpinner",
  "logo": "TherapistsPage-module__nde4IG__logo",
  "menuButton": "TherapistsPage-module__nde4IG__menuButton",
  "menuIcon": "TherapistsPage-module__nde4IG__menuIcon",
  "menuItem": "TherapistsPage-module__nde4IG__menuItem",
  "menuItemLink": "TherapistsPage-module__nde4IG__menuItemLink",
  "menuPaper": "TherapistsPage-module__nde4IG__menuPaper",
  "navContainer": "TherapistsPage-module__nde4IG__navContainer",
  "navLink": "TherapistsPage-module__nde4IG__navLink",
  "navLogo": "TherapistsPage-module__nde4IG__navLogo",
  "navMenu": "TherapistsPage-module__nde4IG__navMenu",
  "navSignup": "TherapistsPage-module__nde4IG__navSignup",
  "navbar": "TherapistsPage-module__nde4IG__navbar",
  "notMobile": "TherapistsPage-module__nde4IG__notMobile",
  "picAndTapeContainer": "TherapistsPage-module__nde4IG__picAndTapeContainer",
  "picAndTapeContainerOuter": "TherapistsPage-module__nde4IG__picAndTapeContainerOuter",
  "pictureContainer": "TherapistsPage-module__nde4IG__pictureContainer",
  "pillar": "TherapistsPage-module__nde4IG__pillar",
  "pillarIcon": "TherapistsPage-module__nde4IG__pillarIcon",
  "pricingSection": "TherapistsPage-module__nde4IG__pricingSection",
  "pulse": "TherapistsPage-module__nde4IG__pulse",
  "root": "TherapistsPage-module__nde4IG__root",
  "scrollIndicator": "TherapistsPage-module__nde4IG__scrollIndicator",
  "sectionLoader": "TherapistsPage-module__nde4IG__sectionLoader",
  "sectionTitle": "TherapistsPage-module__nde4IG__sectionTitle",
  "skeletonCard": "TherapistsPage-module__nde4IG__skeletonCard",
  "skeletonContent": "TherapistsPage-module__nde4IG__skeletonContent",
  "skeletonHeader": "TherapistsPage-module__nde4IG__skeletonHeader",
  "skeletonSection": "TherapistsPage-module__nde4IG__skeletonSection",
  "spin": "TherapistsPage-module__nde4IG__spin",
  "superpowerGrid": "TherapistsPage-module__nde4IG__superpowerGrid",
  "superpowerItem": "TherapistsPage-module__nde4IG__superpowerItem",
  "superpowerSection": "TherapistsPage-module__nde4IG__superpowerSection",
  "superpowerTitle": "TherapistsPage-module__nde4IG__superpowerTitle",
  "tagline": "TherapistsPage-module__nde4IG__tagline",
  "tapeBackgroundContainer": "TherapistsPage-module__nde4IG__tapeBackgroundContainer",
  "tapeContainer": "TherapistsPage-module__nde4IG__tapeContainer",
  "tapeContent": "TherapistsPage-module__nde4IG__tapeContent",
  "tapeDescription": "TherapistsPage-module__nde4IG__tapeDescription",
  "tapeNumber": "TherapistsPage-module__nde4IG__tapeNumber",
  "tapeTitle": "TherapistsPage-module__nde4IG__tapeTitle",
  "tapeTitleNumberMobile": "TherapistsPage-module__nde4IG__tapeTitleNumberMobile",
  "threePillars": "TherapistsPage-module__nde4IG__threePillars",
  "visible": "TherapistsPage-module__nde4IG__visible",
});
